import CounterComponent from '../Counter/Counter';
import './Stats.css';
const stats = [
	{ id: 1, name: 'Number Of Days We Take To Fill A Role', value: 12, prefix: '' },
	{ id: 2, name: 'Number Of Companies We Have Helped', value: 400, prefix: '+' },
	{ id: 3, name: 'Net Promoter Score', value: 87, prefix: '+' },
];

export default function Stats() {
	return (
		<div className=' text-slate-600/10'>
			<div className='fadedown mx-auto textEffect py-32'>
				<div className='mx-auto max-w-7xl px-6 lg:px-8 bottom-0'>
					<dl className='grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3'>
						{stats.map((stat) => (
							<div key={stat.id} className='mx-auto flex max-w-xs flex-col gap-y-4'>
								<p className='text-base leading-7 text-gray-600'>{stat.name}</p>
								<p className='flex flex-row font-semibold items-center justify-center order-first text-8xl text-gray-900 tracking-tight'>
									<CounterComponent Value={stat.value} />
									{stat.prefix.length > 0 && stat.prefix}
								</p>
							</div>
						))}
					</dl>
				</div>
			</div>
		</div>
	);
}
